(() => {
  const node = document.getElementById('tcp-upgrade-text');
  if (!node) return;
  let labels;
  try { labels = JSON.parse(node.textContent); } catch (_) { return; }
  const root = labels.root.endsWith('/') ? labels.root : labels.root + '/';
  let busy = false;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tcp-quick-quantity]');
    if (!button || busy) return;
    const input = button.closest('.tcp-q-form')?.querySelector('input[name="quantity"]');
    if (!input) return;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    input.value = String(Math.max(min, Math.min(max, (Number(input.value) || min) + Number(button.dataset.tcpQuickQuantity) * (Number(input.step) || 1))));
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-tcp-quick-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const form = select.closest('.tcp-q-form');
    const quantity = form.querySelector('input[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    quantity.value = quantity.min;
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    form.querySelector('[data-tcp-quick-pack]').textContent = option.dataset.pack || '';
    const button = form.querySelector('button[type="submit"]');
    button.disabled = option.dataset.available !== 'true';
    form.querySelector('[data-tcp-quick-label]').textContent = button.disabled ? labels.sold : labels.add;
    const link = form.querySelector('[data-tcp-quick-details]');
    const url = new URL(link.href);
    url.searchParams.set('variant', option.value);
    link.href = url.href;
    form.querySelector('[data-tcp-quick-feedback]').textContent = '';
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.tcp-q-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const feedback = form.querySelector('[data-tcp-quick-feedback]');
    if (busy) { feedback.textContent = labels.busy; return; }
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    const quantity = Number(data.get('quantity'));
    if (!Number.isInteger(quantity) || quantity < 1) return;
    data.set('sections', 'cart-drawer,header-cart-status');
    data.set('sections_url', window.location.pathname);
    const controls = [...form.querySelectorAll('button,input,select')].map(control => [control, control.disabled]);
    const label = form.querySelector('[data-tcp-quick-label]');
    busy = true;
    controls.forEach(([control]) => { control.disabled = true; });
    label.textContent = labels.adding;
    feedback.textContent = '';
    delete feedback.dataset.error;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) throw new Error('Cart add failed');
      const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart confirmation failed');
      const cart = await cartResponse.json();
      if (!Number.isInteger(cart.item_count)) throw new Error('Cart confirmation invalid');
      document.dispatchEvent(new CustomEvent('cart:items-updated', { detail: { cart } }));
      try { document.querySelector('ecx-cart-drwr-frm')?.renderContents?.({ sections: result.sections }); } catch (_) {}
      feedback.textContent = labels.added.replace('__quantity__', String(quantity));
    } catch (_) {
      feedback.dataset.error = 'true';
      feedback.textContent = labels.error;
    } finally {
      controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      form.removeAttribute('aria-busy');
      label.textContent = labels.add;
      busy = false;
    }
  }, true);
})();
